import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import {
  useUserInfoQuery,
  AUTH_API_KEY,
  userInfoAtom,
  isEmployeeRoleAllowed,
  setUserInfoAtom,
} from '~entities/auth';
import type { AuthApi } from '~entities/auth';

import { useApi } from '~shared/providers/use-api';
import { Loader } from '~shared/ui/loader/loader';

import { useAtomValue, useSetAtom } from 'jotai';

export const AccessGuard = ({ children }: PropsWithChildren) => {
  const api = useApi<AuthApi>(AUTH_API_KEY);
  const userInfo = useAtomValue(userInfoAtom);
  const setUserInfo = useSetAtom(setUserInfoAtom);

  const { isError } = useUserInfoQuery(api, {
    onSuccess(info) {
      setUserInfo(info);
    },
    enabled: userInfo === null,
  });

  if (isError) {
    return null;
  }

  if (userInfo === null) {
    return <Loader />;
  }

  if (!isEmployeeRoleAllowed(userInfo?.employeeRole)) {
    return <Navigate to="/access-denied" />;
  }

  return <>{children}</>;
};
